export default class AjaxFilteringActivated {
    isEnabled = (device: string): boolean => {
        return device == 'MOBILE'
    }
}